export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative py-20 px-6 bg-gradient-to-b from-[#0a0a0f] to-black border-t border-purple-500/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-purple-500 to-cyan-500">
                <i className="ri-robot-2-line text-2xl text-white" />
              </div>
              <span className="text-2xl font-black text-white">Automate.TR</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Transforming businesses through intelligent automation and AI-driven workflows.
            </p>
            <div className="flex items-center gap-4">
              {['linkedin', 'twitter', 'github', 'youtube'].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 border border-purple-500/30 text-gray-400 hover:text-white hover:border-purple-400 hover:bg-purple-500/20 transition-all duration-300 cursor-pointer"
                >
                  <i className={`ri-${social}-line text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                'Workflow Automation',
                'API Integrations',
                'AI Agent Development',
                'RPA Solutions',
                'Data Pipelines',
                'LLM Integration',
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Industries</h4>
            <ul className="space-y-3">
              {['Energy', 'Logistics', 'Legal', 'Manufacturing', 'Finance', 'Healthcare'].map(
                (item) => (
                  <li key={item}>
                    <a
                      href="#"
                      className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-purple-400 mt-1" />
                <a
                  href="mailto:hello@wotech.com.tr"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer"
                >
                  hello@wotech.com.tr
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-purple-400 mt-1" />
                <a
                  href="tel:+905551234567"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300 cursor-pointer"
                >
                  +90 216 266 0513
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-purple-400 mt-1" />
                <span className="text-gray-400">Istanbul, Turkey</span>
              </li>
            </ul>

            <div className="mt-6 p-4 rounded-xl bg-gradient-to-r from-purple-500/10 to-cyan-500/10 border border-purple-500/30">
              <p className="text-sm text-gray-400 mb-2">
                <i className="ri-shield-check-line text-purple-400 mr-2" />
                GDPR &amp; KVKK Compliant
              </p>
              <p className="text-sm text-gray-400">
                <i className="ri-lock-line text-purple-400 mr-2" />
                ISO 27001 Certified
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-purple-500/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Automate.TR. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-gray-500 hover:text-purple-400 text-sm transition-colors duration-300 cursor-pointer"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-purple-400 text-sm transition-colors duration-300 cursor-pointer"
              >
                Terms of Service
              </a>
              <a
                href="https://wotech.com.tr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-purple-400 text-sm transition-colors duration-300 cursor-pointer"
              >
                About
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
